/* eslint-disable jsdoc/require-jsdoc */

import { ReactElement } from 'react';
import { ParametersType } from '../constants/telosair-interfaces';

export default function ParameterLegend({
  parameter,
  handleParameterClick,
  className,
  active,
  color,
  name,
  textColor
}: {
  parameter: ParametersType;
  handleParameterClick: (clickedParameter: ParametersType, isActive: boolean) => void;
  className: string;
  active: boolean;
  color?: string;
  textColor?: string;
  name: string;
}): ReactElement {
  return (
    <button
      key={parameter}
      type="button"
      onClick={() => handleParameterClick(parameter, active)}
      className={`flex gap-1 items-center cursor-pointer ${className}`}
    >
      <span
        className="material-icons text-sm"
        style={{
          color: color || active ? '#1990FF' : '#fff',
          opacity: !active ? 0.5 : 1
        }}
      >
        circle
      </span>
      <div className={`text-sm font-normal ${textColor || 'text-[#fff]'}`}>{name}</div>
    </button>
  );
}
